/* eslint-disable @typescript-eslint/no-empty-function */
import { registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import { APP_INITIALIZER, ErrorHandler, NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, RouterModule } from '@angular/router';

import { MessagingApiService } from 'projects/ngx-messaging/src/modules/chat/services/messaging-api/messaging-api.service';
import { ChannelsApiService } from 'projects/ngx-messaging/src/modules/chat/services/messaging-api/channels-api.service';
import { IntegrationsApiService } from 'projects/ngx-messaging/src/modules/chat/services/messaging-api/integrations-api.service';
import { MessagesApiService } from 'projects/ngx-messaging/src/modules/chat/services/messaging-api/messages-api.service';
import { MessagingApiStateService } from 'projects/ngx-messaging/src/modules/chat/services/messaging-api/messaging-api-state.service';
import { TagsApiService } from 'projects/ngx-messaging/src/modules/chat/services/messaging-api/tags-api.service';
import { UsersApiService } from 'projects/ngx-messaging/src/modules/chat/services/messaging-api/users-api.service';
import { PhonesService } from 'projects/ngx-messaging/src/modules/chat/services/phones.service';
import { UserModule } from 'projects/ngx-messaging/src/modules/user/user.module';
import { environment } from 'src/environments/environment';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';

import { appReducers } from 'projects/ngx-messaging/src/app.reducer';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './core/services/auth.guard';
import { AuthResolver } from './core/services/auth.resolve';
import { CustomTranslateLoaderService } from './core/services/translations.service';
import { AuthModule } from './modules/auth/auth.module';
import { ChatRoutesService } from './modules/chat/services/chat-routes.service';

registerLocaleData(localeEn);
registerLocaleData(localeEs);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    StoreModule.forRoot(appReducers),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    AuthModule,
    UserModule.forRoot({
      messagingEnvironment: environment,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoaderService, // Usa useClass para utilizar tu servicio personalizado
        deps: [HttpClient, HttpClient], // Solo necesitas inyectar el HttpClient
      },
    }),
  ],
  providers: [
    provideZoneChangeDetection(),
    /*eslint-disable */
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    /* eslint-enable */
    AuthGuard,
    AuthResolver,
    ChatRoutesService,
    PhonesService,
    MessagingApiStateService,
    ChannelsApiService,
    MessagesApiService,
    UsersApiService,
    TagsApiService,
    IntegrationsApiService,
    MessagingApiService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
